import script from "./ProductRegistration.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductRegistration.vue?vue&type=script&setup=true&lang=js"

import "./ProductRegistration.vue?vue&type=style&index=0&id=19aae5dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19aae5dc"]])

export default __exports__